import { MeasurementPointType } from "@/features/measurements";

export enum CheckpointType {
	Checkpoint = "Checkpoint",
	Info = "Info",
	SATOSLive = "SATOSLive",
	ManualMeasurement = "ManualMeasurement",
}

export enum UpdatesColumn {
	Value = "Value",
	AccessLevel = "ansvarlig",
	ConnectedTo = "koble",
	Index = "tabelnr",
	NumberOfFields = "feltstorelse",
	GroupId = "GroupId",
	IsSkipped = "IsSkipped",
	IsOverridden = "IsOverridden",
	BackgroundColor = "BackgroundColor",
	CheckpointType = "CheckpointType",
}

export interface CreateChecklistRequest {
	ProcedureId: number;
	NodeId: number;
	ChecklistType: ChecklistTypes;
}

export interface CreateChecklistResponse {
	ChecklistId: number;
}

export interface AddLiveTagToStepRequest {
	StepId: number;
	ChecklistId: number;
	MeasurementTag: LiveTagRequest;
}

interface LiveTagRequest {
	Id: number | string;
	Name: string;
	TagId: string;
	PointType?: MeasurementPointType;
	MinValue: number;
	MaxValue: number;
}

export interface CreateChecklistStepRequest {
	ProcedureId: number;
	ChecklistId: number;
	StepId: number;
	CheckpointType: CheckpointType;
}

export interface UpdateChecklistStepRequest {
	StepId: number;
	ChecklistId: number;
	Updates: Partial<Record<UpdatesColumn, any>>;
}

export interface DeleteChecklistStepRequest {
	StepId: number;
	ChecklistId: number;
}

export interface RemoveLiveTagFromStepRequest {
	StepId: number;
	ChecklistId: number;
	MeasurementTagId: number;
}

export interface RemoveManualMeasurementPointFromStepRequest {
	StepId: number;
	ChecklistId: number;
	MeasurementTagId: number;
}

export enum ChecklistTypes {
	ManualChecklist = 0,
	ImportedChecklist = 1,
	MaterialHandlingChecklist = 2,
}
